/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
		scrollTop: 0,
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $("[data-target='#navbarNav']").click(function(){
          var $this = $(this);
          if( $this.hasClass( "collapsed" ) ){
            $("body").addClass( "primary-navigation-opened" );
            $this.removeClass( "collapsed" );
          }else {
            $("body").removeClass( "primary-navigation-opened" );
            $this.addClass( "collapsed" );
          }
        });
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        // CountUp stuff
        var options = {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
        };

        setTimeout(function () {
          $('.stats .stat').each(function () {
            var the_id = $('.percentage span', this).attr('id');
            var speed = $('.percentage', this).data('speed');
            var number = $('.percentage', this).data('number');

            var demo = new CountUp(the_id, 0, number, 0, speed, options);

            if (!demo.error) {
              demo.start();
            } else {
              console.error(demo.error);
            }
          });
        }, 1500);
        // End CountUp Stuff
      }
    },
    'page_template_wesense': {
      init: function(){
      },
      finalize: function() {

        // CountUp stuff
        var options = {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
        };

        setTimeout(function () {
          $('.stats .stat').each(function(){
            var the_id = $('.percentage span', this).attr('id');
            var speed = $('.percentage', this).data('speed');
            var number = $('.percentage', this).data('number');
            
            var demo = new CountUp(the_id, 0, number, 0, speed, options);
            
            if (!demo.error) {
              demo.start();
            } else {
              console.error(demo.error);
            }
          });
        }, 1500);
        // End CountUp Stuff

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
    'archive': function(){
      $( window ).scroll( function( e ){
        var height = $( "body" ).height();
        var scroll = $( this ).scrollTop() + height;
        var $btn = $( '.load-more' );
        var position = $btn.length > 0 ? $btn.offset().top : 0;
        var offset = 1000;
        if( position && ( scroll ) >= ( ( height / 3 ) * 2 ) && !$btn.hasClass( "loading" ) ){
          $btn.trigger( 'click' );
        }
      } );
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
